var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-progress"},_vm._l((_vm.multiLine),function(i){return _c('div',{key:i,staticClass:"rounded h--5 mw--100 bg-gradient-loading mb-2"})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }